const validateKeyword = (rule, value, callback) => {
  // const patter = new RegExp('^,|[，。？！.?!]+|(,,)+|,$')
  const arr = value.split(",").filter((item) => item === "");
  // if (patter.test(value)) {
  //     return callback(new Error('多个关键词，只能以英文逗号分隔'))
  // } else
  if (arr.length > 0) {
    return callback(new Error("字符串中存在多余英文逗号"));
  } else {
    callback(); // 必须有此项回调，否则验证会一直不通过
  }
};
export default {
  // 表单校验
  title: [
    { required: true, message: "标题不能为空", trigger: "blur" },
    {
      type: "string",
      min: 5,
      max: 50,
      message: "标题限制5到50个字数",
      trigger: "blur",
    },
  ],
  keyword: [
    { required: true, message: "关键词不能为空", trigger: "blur" },
    { validator: validateKeyword, trigger: "blur" },
  ],
  artSummary: [
    { required: true, message: "摘要不能为空", trigger: "blur" },
    {
      type: "string",
      max: 2500,
      message: "内容摘要超出字数限制",
      trigger: "blur",
    },
  ],
  periodical: [{ required: true, message: "刊名不能为空", trigger: "blur" }],
  articleColumn: [{ required: true, message: "栏目不能为空", trigger: "blur" }],
  classifyNumber: [
    { required: true, message: "分类号不能为空", trigger: "blur" },
    {
      type: "string",
      pattern: /^[a-zA-Z0-9\.\,\+\-\/]+$/,
      message: "请输入正确的分类号",
      trigger: "blur",
    },
  ],
  reportCode: [
    { required: true, message: "报告编号不能为空", trigger: "blur" },
    {
      type: "string",
      pattern: /^[a-zA-Z0-9]+$/,
      message: "报告编号只能是数字和字母",
      trigger: "blur",
    },
  ],
  isbn: [
    { required: true, message: "ISBN不能为空", trigger: "blur" },
    {
      type: "string",
      max: 20,
      message: "ISBN最多输入20个字符",
      trigger: "blur",
    },
  ],
  doi: [{ required: true, message: "DOI不能为空", trigger: "blur" }],
  pageNumber: [{ required: true, message: "页数不能为空", trigger: "blur" }],
  accessoryName: [
    { required: true, message: "附件不能为空", trigger: "change" },
  ],
  firstAuther: [
    { required: true, message: "第一作者不能为空", trigger: "change" },
  ],
  firstUnitId: [
    { required: true, message: "第一作者单位不能为空", trigger: "change" },
  ],
  journalsYear: [
    {
      required: true,
      type: "string",
      message: "年份不能为空",
      trigger: "change",
    },
  ],
  journalsTerm: [{ required: true, message: "期数不能为空", trigger: "blur" }],
  startPageNumber: [
    { required: true, message: "开始页码不能为空", trigger: "blur" },
  ],
  endPageNumber: [
    { required: true, message: "结束页码不能为空", trigger: "blur" },
  ],
  // 表单中资金项目中表单验证
  num: [{ required: true, message: "项目号不能为空", trigger: "blur" }],
  name: [{ required: true, message: "项目名称不能为空", trigger: "blur" }],
  enName: [
    {
      type: "string",
      pattern: /^[^\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+$/,
      message: "请勿填写中文",
      trigger: "blur",
    },
  ],
  englishTitle: [
    {
      type: "string",
      pattern: /^[^\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+$/,
      message: "请勿填写中文",
      trigger: "blur",
    },
  ],
  englishKeyword: [
    {
      type: "string",
      pattern: /^[^\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+$/,
      message: "请勿填写中文",
      trigger: "blur",
    },
  ],
  englishArtSummary: [
    {
      type: "string",
      pattern: /^[^\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+$/,
      message: "请勿填写中文",
      trigger: 'change | blur',
    },
  ],
  englishPeriodical: [
    {
      type: "string",
      pattern: /^[^\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+$/,
      message: "请勿填写中文",
      trigger: "blur",
    },
  ],
  englishFirstAuthor: [
    {
      type: "string",
      pattern: /^[^\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+$/,
      message: "请勿填写中文",
      trigger: "blur",
    },
  ],
  englishCommunicationAuthor: [
    {
      type: "string",
      pattern: /^[^\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+$/,
      message: "请勿填写中文",
      trigger: "blur",
    },
  ],
  curNum: [
    { required: true, message: "标题不能为空", trigger: "blur" },
    {
      type: "string",
      min: 5,
      max: 50,
      message: "标题限制5到50个字数",
      trigger: "blur",
    },
  ],
  content: [{ required: true, message: "正文不能为空", trigger: "change | blur" }],
  abstract: [
    { type: "string", max: 500, message: "摘要限制500个字", trigger: "blur" },
  ],
  isOriginal: [
    { required: true, message: "请选择是否原创", trigger: "change" },
  ],
  source: [{ required: true, message: "来源不能为空", trigger: "blur" }],
  classification: [
    {
      required: true,
      message: "请选择分类",
      trigger: "change",
    },
  ],
  cover: [{ required: true, message: "请上传封面", trigger: "change" }],
  reportName: [
    { required: true, message: "标题不能为空", trigger: "blur" },
    {
      type: "string",
      min: 5,
      max: 50,
      message: "标题限制5到50个字数",
      trigger: "blur",
    },
  ],
  englishName: [
    {
      type: "string",
      pattern: /^[^\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+$/,
      message: "请勿填写中文",
      trigger: "blur",
    },
  ],
  reportCharge: [
    { required: true, message: "请选择报告类型", trigger: "change" },
  ],
  sizeNumber: [
    { required: true, message: "报告页码不能为空", trigger: "blur" },
  ],
  reportNumber: [
    { required: true, message: "表格数量不能为空", trigger: "blur" },
  ],
  sendWay: [{ required: true, message: "寄送方式不能为空", trigger: "blur" }],
  catalogue: [{ required: true, message: "目录不能为空", trigger: "change" }],
  businessId1name: [
    { required: true, message: "一级行业分类不能为空", trigger: "change" },
  ],
  businessId2name: [
    { required: true, message: "二级行业分类不能为空", trigger: "change" },
  ],
  press: [{ required: true, message: "出版单位不能为空", trigger: "blur" }],
  publishTime: [
    { required: true, message: "出版时间不能为空", trigger: "change" },
  ],
  edition: [{ required: true, message: "版次不能为空", trigger: "blur" }],
  monographLenght: [
    { required: true, message: "字数不能为空", trigger: "blur" },
    {
      type: "string",
      pattern: /^[0-9\u4E00-\u9FA5\.]+$/,
      message: "字数格式不正确",
      trigger: "blur",
    },
  ],
  externalUrl: [
    {
      type: "string",
      pattern:
        /^((http:|https:)+(\/\/)+[A-Za-z0-9]+\.[^\s]*?(([A-Za-z0-9]+-[A-Za-z0-9]+|[A-Za-z0-9]+)\.))+([a-z]+)[/?:]?.*$/,
      message: "外部链接格式不正确",
      trigger: "blur",
    },
  ],
  urlAddr: [
    { required: true, message: "课程地址不能为空", trigger: "blur" },
    {
      type: "string",
      pattern:
        /^((http:|https:)+(\/\/)+[A-Za-z0-9]+\.[^\s]*?(([A-Za-z0-9]+-[A-Za-z0-9]+|[A-Za-z0-9]+)\.))+([a-z]+)[/?:]?.*$/,
      message: "课程地址格式不正确",
      trigger: "blur",
    },
  ],
  payUrl: [
    {
      type: "string",
      pattern:
        /^((http:|https:)+(\/\/)+[A-Za-z0-9]+\.[^\s]*?(([A-Za-z0-9]+-[A-Za-z0-9]+|[A-Za-z0-9]+)\.))+([a-z]+)[/?:]?.*$/,
      message: "商品链接格式不正确",
      trigger: "blur",
    },
  ],
  beginTime: [{ required: true, message: "请选择开始时间", trigger: "change" }],
  provinceCode: [{ required: true, message: "请选择省", trigger: "change" }],
  cityCode: [{ required: true, message: "请选择市", trigger: "change" }],
  originalPublishTime: [
    { required: true, message: "请选择来源发布时间", trigger: "change" },
  ],
  contactsName: [{ required: true, message: "请输入会议联系人姓名", trigger: "blur" }],
  contactsInfo: [{ required: true, message: "请输入会议联系人电话/邮箱", trigger: "blur" }],
  meetingType: [{ required: true, type: 'number', message: "请选择会议类型", trigger: "change" }],
  open: [{ required: true, type: 'number', message: "请选择是否开启报名", trigger: "change" }],
  solicitContent: [{ required: true, message: "请至少输入征稿信息", trigger: "change" }],
  author: [{
    type: "string",
    max: 20,
    message: "资讯作者限制20个字数",
    trigger: "blur",
  }],
  saleType: [{ required: true, type: "number", message: "请选择售卖方式", trigger: "change" }],
};
